import { render } from "./ChildNotesDialog.vue?vue&type=template&id=02efc615&scoped=true"
import script from "./ChildNotesDialog.vue?vue&type=script&lang=js"
export * from "./ChildNotesDialog.vue?vue&type=script&lang=js"

import "./ChildNotesDialog.vue?vue&type=style&index=0&id=02efc615&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02efc615"]])

export default __exports__